<template>
  <div :class="['ms-form', 'ms-form--narrow', {purpose: this.data?.body?.purpose}]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomSelect
          :options="this.grades"
          label="Грейд"
          optionValueKey="grade_id"
          optionLabelKey="grade_name"
          :value="this.formData.grade_id || ''"
          @change="(value) => onChange('grade_id', value)"
          :required="true"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import {getGrades} from "@/views/timeline/services";

export default {
  name: "change-remont-grade",
  components: {CustomSelect, CustomModalFooter},
  props: ['data'],
  data() {
    return {
      loading: false,
      grades: [],
      formData: {
        grade_id: this.data?.body?.grade_id || '',
      }
    }
  },
  methods: {
    async getGradesData() {
      const res = await getGrades()
      if(!res) return
      this.grades = res
    },
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
  },
  mounted() {
    this.getGradesData()
  }
}
</script>
